<div>
  <div class="row">
    <div class="col-12">
      <h2 class="titleTextFont font-weight-normal text-center" style="font-size: 2.4rem;"
        [ngStyle]="{'color': titlesColor ? titlesColor : ''}">
        {{ title }}
      </h2>
    </div>
    <div class="col-12">
      <h2 class="font-weight-normal fadeIn text-center mb-3 subtitle-block" style="font-size: 1.5rem;"
        [ngStyle]="{'color': secondaryColor ? secondaryColor : ''}">
        {{ subtitleText }}
      </h2>
    </div>
  </div>

  <div id="pricing" class="container events-list mt-5 mb-5 fadeIn">
    <div class="row">
      <div class="col-md-4 col-12 mb-3" *ngFor="let item of plans">
        <div
          class="card p-3 mx-auto"
          [class.selected]="item?.selected"
        >
          <div class="card-body text-center d-flex flex-column justify-content-between">
            <h5 class="card-title mb-0" style="height: 70px">{{ item?.name }}</h5>
            <div class="row justify-content-center">
              <div class="col-auto mb-1 my-4">
                <img [src]="item?.icon" alt="" class="icon-plan" />
              </div>
            </div>
            <div class="card-princing">
              <p class="mb-1">USD {{ item?.price_global }}</p>
              <span class="usd">{{ currency }} {{ item?.price }}</span>
              <div
                *ngIf="item?.price != 0 && item?.price_global != 0"
                class="text-interval-card"
              >
                {{ item?.showInterval }}
              </div>
            </div>
            <div class="col" style="max-height: 10rem; min-height: 10rem">
              <p class="text-footer-card">
                {{ item.access_info }}
              </p>
              <div class="row justify-content-center">
                <div class="col-10">
                  <div class="desc">{{ item.description }}</div>
                </div>
              </div>
            </div>

            <p class="see-more">
              Ver mas
            </p>
          </div>
        </div>
        <div class="row justify-content-center mx-auto">
          <button
            [disabled]="item?.selected"
            type="button"
            class="openModal col-md-12 col-9 my-3"
          >
            {{ item.selected ? 'Tu plan actual' : 'Empezar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
